import React from "react";
import { VStack, Text } from "@chakra-ui/react";
import { useFormContext } from "react-hook-form";
import { KYDInput } from "src/ui";
import AudienceListItem from "../../AudienceListItem";
import { StepProps, CreateCustomAudienceFormValues } from "../types";

const LookalikeStep: React.FC<StepProps> = ({ lookalikeOptions }) => {
  const form = useFormContext<CreateCustomAudienceFormValues>();

  return (
    <VStack spacing={6} align="stretch">
      <VStack align="stretch" spacing={4}>
        <KYDInput
          variant="labeled"
          label="Lookalike audience name"
          placeholder="Enter lookalike audience name"
          value={form.watch("lookalike.name")}
          defaultValue={`Lookalike ${form.watch("name")}`}
          onChange={(e) => form.setValue("lookalike.name", e.target.value)}
        />

        <VStack align="stretch" spacing={2}>
          {/* <Text fontSize="sm" fontWeight="500">
            Similarity Ratio
          </Text>
          <Text fontSize="xs" color="gray.600">
            Choose how similar the lookalike audience should be to your source
            audience. Lower percentages create more similar but smaller
            audiences.
          </Text> */}

          <VStack spacing={3} align="stretch">
            {lookalikeOptions.map((option) => (
              <AudienceListItem
                key={option.value}
                title={option.title}
                description={option.description}
                icon={option.icon}
                iconBgColor={option.iconBgColor}
                value={option.value}
                isSelected={form.watch("lookalike.ratio") === option.value}
                onSelect={(value) => form.setValue("lookalike.ratio", value)}
                isRecommended={option.isRecommended}
                showRadio={true}
                showPlus={false}
              />
            ))}
          </VStack>
        </VStack>
      </VStack>
    </VStack>
  );
};

export default LookalikeStep;
